module.exports = {"children":false,"jsPrefix":"Img","sizes":{"thumb":40,"min":200,"max":400,"inc":200},"quality":{"image":30,"thumb":30},"thumbBlurLarge":3,"thumbBlurSmall":1,"location":"./src/content/images"}


//////////////////
// WEBPACK FOOTER
// ./images.config.json
// module id = cM4a
// module chunks = 0